import store from '../store';
import Constants from '../config/constants';
import {serviceGetIncentiveReportEarlyBird} from "../services/IncentiveReport.service";

export const FETCH_INIT = 'FETCH_INIT_EARLY_BIRD';
export const FETCHED = 'FETCHED_EARLY_BIRD';
export const FETCHED_FAIL = 'FETCHED_FAIL_EARLY_BIRD';
export const FETCHED_FILTER = 'FETCHED_FILTER_EARLY_BIRD';
export const FETCH_NEXT = 'FETCH_NEXT_EARLY_BIRD';
export const FILTER = 'FILTER_EARLY_BIRD'; 
export const RESET_FILTER = 'RESET_FILTER_EARLY_BIRD';
export const SET_SORTING = 'SET_SORTING_EARLY_BIRD';
export const SET_FILTER = 'SET_FILTER_EARLY_BIRD';
export const SET_PAGE = 'SET_PAGE_EARLY_BIRD';
export const CHANGE_PAGE = 'CHANGE_PAGE_EARLY_BIRD';
export const CHANGE_STATUS= 'CHANGE_STATE_EARLY_BIRD';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_EARLY_BIRD';
export const CREATE_DATA = 'CREATE_EARLY_BIRD';
export const UPDATE_DATA = 'UPDATE_EARLY_BIRD';
export const DELETE_ITEM = 'DELETE_EARLY_BIRD';


export function actionFetchIncentiveReportEarlyBird(index = 1, sorting = {}, filter = {}) {
    const request = serviceGetIncentiveReportEarlyBird({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionChangePageIncentiveReportEarlyBird(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}


export function actionFilterIncentiveReportEarlyBird(value) {
    const request = null;
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});
        });
    };
}


export function actionChangeStatusIncentiveReportEarlyBird(id, status) {
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterIncentiveReportEarlyBird() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageIncentiveReportEarlyBird(page, extraPayload = {}) {
    const stateData = store.getState().early_bird;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data; 
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchIncentiveReportEarlyBird(serverPage + 1, sortingData, {query, query_data: queryData,   ...extraPayload}));
    }

    console.log(currentPage, totalLength);
    return {
        type: CHANGE_PAGE,
        payload: page,
    };

}
